/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var youtubeIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      d: "M5.6,7.00005762 L5.6,2.8 L9.2372227,4.90002881 L5.6,7.00005762 Z M13.7075194,1.53027946 C13.5464131,0.928032267 13.072083,0.453586863 12.4697205,0.292595794 C11.3779314,0 6.99994238,0 6.99994238,0 C6.99994238,0 2.62206857,0 1.53027946,0.292595794 C0.927917027,0.453586863 0.453586863,0.928032267 0.292595794,1.53027946 C0,2.62206857 0,4.90002881 0,4.90002881 C0,4.90002881 0,7.17798905 0.292595794,8.26977816 C0.453586863,8.87202535 0.927917027,9.34647076 1.53027946,9.50746183 C2.62206857,9.80005762 6.99994238,9.80005762 6.99994238,9.80005762 C6.99994238,9.80005762 11.3779314,9.80005762 12.4697205,9.50746183 C13.072083,9.34647076 13.5464131,8.87202535 13.7075194,8.26977816 C14,7.17798905 14,4.90002881 14,4.90002881 C14,4.90002881 14,2.62206857 13.7075194,1.53027946 Z"
    })]
  });
});

export { youtubeIcon as default };
